module.exports = __webpack_public_path__ + "img/title_3.4f9f54c9.png";